// Auto-generated normalizer for table: Cat_TipoPregunta
export function catTipoPreguntaNormalize(row) {
  return {
    idTipoPregunta: row.idTipoPregunta ?? row.IdTipoPregunta ?? row['IdTipoPregunta'] ?? 0,
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
